import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API_URL from "../../config/ApiUrl";
import axios from "axios";

export const getDocuments = createAsyncThunk(
    "Documents/get",
    async (payload, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setActivePayload(payload));
            const filteredPayload = Object.fromEntries(
                Object.entries(payload).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ""
                )
            );
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(filteredPayload)) {
                if (Array.isArray(value)) {
                    // If the value is an array, append each item with the same key
                    value.forEach((item) => {
                        params.append(key, item);
                    });
                } else {
                    // For non-array values, just append normally
                    params.append(key, value);
                }
            }
            const queryString = params.toString();

            const { data } = await axios.get(`${API_URL.VERIFICATION.GET_DOCUMENTS}?${queryString}`);
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createDocument = createAsyncThunk(
    "Document/create",
    async (payload, { rejectWithValue, dispatch, getState }) => {
        try {
            const { data } = await axios.post(`${API_URL.VERIFICATION.GET_DOCUMENTS}`, payload);
            const { active_payload } = getState().document;
            dispatch(getDocuments(active_payload));
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const deleteDocument = createAsyncThunk(
    "Document/delete",
    async (id, { rejectWithValue, dispatch, getState }) => {
        try {
            const { data } = await axios.delete(`${API_URL.VERIFICATION.GET_DOCUMENTS}/${id}`);
            const { active_payload } = getState().document;
            dispatch(getDocuments(active_payload));
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const editDocument = createAsyncThunk(
    "Document/put",
    async (payload, { rejectWithValue, dispatch, getState }) => {
        try {
            const { data } = await axios.put(`${API_URL.VERIFICATION.GET_DOCUMENTS}`, payload);
            const { active_payload } = getState().document;
            dispatch(getDocuments(active_payload));
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const getDocumentsForPicker = createAsyncThunk(
    "Document/pickerList",
    async (searchText, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({ PageSize: "500", PageNumber: "1" });
            if (searchText) params.append("SearchText", searchText);
            const { data } = await axios.get(`${API_URL.VERIFICATION.GET_DOCUMENTS}?${params.toString()}`);
            return data?.data?.list ?? [];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getDocumentChildren = createAsyncThunk(
    "Document/getChildren",
    async (parentId, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${API_URL.VERIFICATION.GET_DOCUMENTS}/${parentId}/Children`);
            return data?.data ?? [];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const saveDocumentChildren = createAsyncThunk(
    "Document/saveChildren",
    async ({ parentId, childDocumentIds }, { rejectWithValue }) => {
        try {
            const { data } = await axios.post(`${API_URL.VERIFICATION.GET_DOCUMENTS}/${parentId}/Children`, { childDocumentIds });
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

const documentSlice = createSlice({
    name: "document",
    initialState: {
        document_list: [],
        current_values: null,
        active_payload: null,
    },
    reducers: {
        setCurrentValues(state, action) {
            state.current_values = action.payload;
        },
        setActivePayload(state, action) {
            state.active_payload = action.payload;
        },
        resetCurrentValue(state) {
            state.current_values = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getDocuments.fulfilled, (state, action) => {
            state.document_list = action.payload.data.list;
        });
    },
});
export const { setCurrentValues, setActivePayload, resetCurrentValue } =
    documentSlice.actions;
export default documentSlice.reducer;